export default __webpack_public_path__ + "static/media/MonPharmacien-Logo.7daf2ff0.svg";